
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DetalleCentroComponent} from 'src/app/components/portal-inproeco/centro/tabla-centros/detalle-centro/detalle-centro.component'
/* import { DetalleContratistaComponent} from 'src/app/components/portal-inproeco/contratista/detalle-contratista/detalle-contratista.component';
import { detalleContenidoComponent} from 'src/app/components/portal-inproeco/cliente/detalle-cliente/detalle-cliente.component';
import { DetalleGestorComponent} from 'src/app/components/portal-inproeco/gestor/detalle-gestor/detalle-gestor.component'; */


@Injectable({
  providedIn: 'root'
})
export class DetalleService {
  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<any>) { }

  public openTest(options: any, component: any) {
    this.dialogRef = this.dialog.open(component, {
         data: {
          id:options.id,
          nAuth:options.nAuth,
          refresh: options.refresh
         }
    });
  } 

  public confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
      return res;
    }
  ));
  }
  }

